import { css } from 'linaria';

export namespace Styles {
  export const stickyPanelWithNavigation = css`
    top: 0;
    z-index: 1;
  `;

  export const aStyle = css`
    color: unset;
  `;

  export const addToBasket = css`
    min-width: 116px;
    width: 116px;
  `;

  export const counter = css`
    padding: 0 var(--space-75);
    input {
      font-size: 14px !important;
    }
  `;
}
